export default __webpack_public_path__ + "static/media/elec-3.93027161.png";